export function isTrialEnded(user) {
  return (
    user?.workspace?.type === 'enterprise' &&
    user?.workspace?.trial_mode &&
    new Date().getTime() > new Date(user?.workspace?.trial_end_date).getTime()
  );
}
